import { ShippingProfilesApiClient } from '@fourthwall/services/dist/ShippingProfilesApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useShippingProfilesQuery = createQueryHook(
  ShippingProfilesApiClient.getShippingProfiles,
  {
    queryKey: ['shippingProfiles'],
  },
)
